import * as React from 'react';
import { connect } from 'react-redux';
import * as Moment from 'moment';
import { CalendarAppState } from '../classes/redux-states';
import { Dispatch } from 'redux';
import { ActionType, setContent, incrementMonth, decrementMonth } from '../redux/actions/actions';
import { IAAPDEvent } from '../classes/event';

export interface ExternalProps {
}

export interface StateToProps {
  calendarState: CalendarAppState;
}

interface DispatchToProps {
  decrementMonth: () => any;
  incrementMonth: () => any;
}

interface MonthSelectionState {
}

type MonthSelectionProps = ExternalProps & StateToProps & DispatchToProps;

export class MonthSelectionJumpComponent extends React.Component<MonthSelectionProps, MonthSelectionState> {
  constructor(props: MonthSelectionProps) {
    super(props);

    this.scrollUp = this.scrollUp.bind(this);
    this.decrementScrollUp = this.decrementScrollUp.bind(this);
    this.incrementScrollUp = this.incrementScrollUp.bind(this);
  }

  componentDidMount(){
  }

  scrollUp() {
    let filtersTop = document.querySelector('#calendar-filter-container') as HTMLDivElement;
    let stickyHeader = document.querySelector('.page-header > nav > div').clientHeight;

    filtersTop.scrollIntoView();
  }

  decrementScrollUp() {
    this.scrollUp();

    this.props.decrementMonth();
  }

  incrementScrollUp() {
    this.scrollUp();

    this.props.incrementMonth();
  }

  render() {
    let displayedDate = this.props.calendarState.calendarApiModel.selectedDate.toDate();
    let today = new Date();

    return (
      <nav className="calendar-container-controls">
        <button className="month-ctrl month-prev" onClick={this.decrementScrollUp} >
          <svg className="svg-icon open" aria-hidden="true" focusable="false">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron" />
          </svg>
          <span className="visually-hidden">Previous Month</span>
        </button>

        <h2>{this.props.calendarState.calendarApiModel.selectedDate.format("MMMM YYYY")}</h2>
        
        <button className="month-ctrl month-next" onClick={this.incrementScrollUp}>
          <svg className="svg-icon open" aria-hidden="true" focusable="false">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron" />
          </svg>
          <span className="visually-hidden">Next Month</span>
        </button>

      </nav>
    )
  }
}

function mapStateToProps(state: CalendarAppState) {
  return {
    calendarState: state
  }
}

function mapDispatchToProps(dispatch: Dispatch<CalendarAppState>): DispatchToProps {

  return {
    decrementMonth: () => dispatch(decrementMonth()),
    incrementMonth: () => dispatch(incrementMonth())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthSelectionJumpComponent);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/month-selection-jump.tsx